import { useSelector } from "react-redux";
interface TotalDataProps{
  hlanguage:any;
  allImagesLink:any;
}

const TotalData = ({hlanguage,allImagesLink}:TotalDataProps) => {
      // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);
  const base_Url = process.env.REACT_APP_BASE_URL;
  return (
    <div>
      <div
        className="text-white py-lg-5 d-flex justify-content-around align-items-center"
        style={{
          backgroundImage: `url(${base_Url}${
                allImagesLink?.others?.find(
                  (item: any) => item?.fileName?.includes("counts_bg.png")
                )?.fileUrl
              })`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          minHeight: "130px", // responsive height
        }}
      >
        <div className="d-flex flex-column text-center">
          <p
            className="mb-1 fw-bold"
            style={{ fontSize: "clamp(20px, 5vw, 42px)" }}
          >
            224
          </p>
          <h3 className="text-white" style={{ fontSize: "clamp(12px, 3vw, 18px)" }}>
            {hlanguage.totAPMCs}
          </h3>
        </div>

        <div className="d-flex flex-column text-center">
          <p
            className="mb-1 fw-bold"
            style={{ fontSize: "clamp(20px, 5vw, 42px)" }}
          >
            780
          </p>
          <h3 className="text-white" style={{ fontSize: "clamp(12px, 3vw, 18px)" }}>
            {hlanguage.totComm}
          </h3>
        </div>

        <div className="d-flex flex-column text-center">
          <p
            className="mb-1 fw-bold"
            style={{ fontSize: "clamp(20px, 5vw, 42px)" }}
          >
            33
          </p>
          <h3 className="text-white" style={{ fontSize: "clamp(12px, 3vw, 18px)" }}>
            {hlanguage.totDist}
          </h3>
        </div>

        <div className="d-flex flex-column text-center">
          <p
            className="mb-1 fw-bold"
            style={{ fontSize: "clamp(20px, 5vw, 42px)" }}
          >
            352
          </p>
          <h3 className="text-white" style={{ fontSize: "clamp(12px, 3vw, 18px)" }}>
            {hlanguage.totTal}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default TotalData;
